import { render, staticRenderFns } from "./NewsGrid.vue?vue&type=template&id=e69a1f58"
import script from "./NewsGrid.vue?vue&type=script&lang=js"
export * from "./NewsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports